import * as ProfileActions from './profileActions';
import { AuthenticationTypes } from '../../lib/PST.Web.Common/src/services/authentication/base';

export const ProfileMiddleware = ({ dispatch }) => (next) => (action) => {
    if (action.type === AuthenticationTypes.LOG_OUT) {
        dispatch(ProfileActions.clearState());
    }

    return next(action);
};
